import React from 'react';

const Invalid = () => <p>This trade is invalid. Check values above and try resubmitting</p>;

export default Invalid;
